import { BaseApi } from './baseApi';

export class ReviewsApi extends BaseApi {
    constructor(options) {
        super(options);

        this.accessToken = null;
    }

    request(endpoint, options) {
        let params = {};
        if (Array.isArray(endpoint)) [endpoint, params] = endpoint;
        if (this.accessToken) params.accessToken = this.accessToken;

        return super.request([endpoint, params], options);
    }

    list(workspaceId, params) {
        return super.get([`/workspaces/${workspaceId}/reviews`, params]);
    }

    my(workspaceId) {
        return super.get(`/workspaces/${workspaceId}/reviews/my`);
    }

    create(workspaceId, body) {
        return super.post(`/workspaces/${workspaceId}/reviews`, body);
    }

    delete(workspaceId, reviewId) {
        return super.delete(`/workspaces/${workspaceId}/reviews/${reviewId}`);
    }
}

export default new ReviewsApi();
